// src/utils/highlighter.ts
import { createLowlight, common } from "lowlight";
var lowlight = createLowlight(common);

export {
  lowlight
};
